import { html } from '../core/html.js';
import { t } from '../core/i18n.js';
import { routeHref } from '../core/url.js';
import { formatDate } from '../core/format.js';
import { page, breadcrumbs } from '../components/chrome.js';
import { artwork } from '../components/artwork.js';
import { ctaSection } from '../components/ctaSection.js';
import { icon } from '../components/icon.js';
import { posts, postPath } from '../data/posts.js';

const pad = (value) => String(value).padStart(2, '0');
const topics = [...new Set(posts.map((post) => post.topicKey))];

const pageHead = () => html`
  <section class="pagehead" aria-labelledby="blog-title">
    <div class="shell">
      ${breadcrumbs('nav.blog')}
      <div class="pagehead__grid">
        <div>
          <p class="kicker">${t('blog.label')}</p>
          <h1 class="pagehead__title" id="blog-title">${t('blog.title')}</h1>
          <p class="pagehead__lede">${t('blog.lede')}</p>
        </div>
        <aside class="pagehead__aside">
          <p class="pagehead__note"><strong>${pad(posts.length)}</strong>${t('blog.count')}</p>
          <p class="pagehead__meta">${topics.map((key) => t(key)).join(' · ')}</p>
        </aside>
      </div>
    </div>
  </section>
`;

/**
 * One teaser. The newest post is laid out wide. The title is the link; it
 * stretches over the whole card, and the cover is decoration.
 */
export const postCard = (post, { featured = false } = {}) => html`
  <li class="${featured ? 'post-card post-card--featured' : 'post-card'}" style="--accent: ${post.accent}" data-reveal>
    <div class="post-card__media media-frame">
      ${artwork(post.cover, '', {
        sizes: featured ? '(max-width: 900px) 100vw, 60vw' : '(max-width: 720px) 100vw, 33vw',
      })}
    </div>
    <div class="post-card__body">
      <p class="post-card__meta">
        <time datetime="${post.published}">${formatDate(post.published)}</time>
        <span aria-hidden="true">·</span>
        <span>${t(post.topicKey)}</span>
        <span aria-hidden="true">·</span>
        <span>${t('blog.readingTime', { minutes: post.minutes })}</span>
      </p>
      <h2 class="post-card__title">
        <a class="post-card__link" href="${routeHref(postPath(post))}">${t(`post.${post.slug}.title`)}</a>
      </h2>
      <p class="post-card__text">${t(`post.${post.slug}.description`)}</p>
      <span class="post-card__more" aria-hidden="true">${t('blog.read')}${icon('arrowRight', { size: 15 })}</span>
    </div>
  </li>
`;

const list = () => html`
  <section class="section blog-list" aria-labelledby="blog-list-title">
    <div class="shell">
      <div class="section-label">
        <span class="section-label__num">01</span>
        <span id="blog-list-title">${t('blog.list.label')}</span>
      </div>
      <ol class="blog-list__grid">
        ${posts.map((post, index) => postCard(post, { featured: index === 0 }))}
      </ol>
    </div>
  </section>
`;

export const BlogPage = () => page(html`${pageHead()}${list()}${ctaSection()}`);
